module.exports = __webpack_public_path__ + "img/family.06d6edab.svg";